import { type MetaFunction } from '@remix-run/node'
import foremost from './foremost.png'

export const meta: MetaFunction = () => [
	{ title: 'Foremost Insurance Group' },
	{
		name: 'description',
		content: 'We offer insurance from Foremost Insurance Group.',
	},
]
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Foremost</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={foremost} alt="Foremost" className="w-64" />
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					The company dates back to 1952 when it was started by a group of
					people with the idea of insuring mobile homes. The company has grown
					to include many other insurance products in its lineup.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Foremost has a very comprehensive set of personal lines insurance
					products, including Home, Mobilehome, Auto, Motorcycle, Flood,
					Snowmobile, and Boat.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best has awarded foremost with the financial strength rating of A
					(Excellent) because of their excellent position to be able to meet
					ongoing obligations to policyholders.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.foremost.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.foremost.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					1-800-527-3907
				</p>

				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Foremost Online Payment"
						href="https://foremost.com/payonline/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://foremost.com/payonline/ (opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					P.O. Box 0915
					<br />
					Carol Stream, IL 60132-0915
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Foremost Insurance Group
					<br />
					5600 Beech Tree Lane
					<br />
					Caledonia, MI 49316
				</p>
			</section>
		</main>
	)
}
